import { TRACKING_WORD_DELIMITER } from "../analytics/constants";
import {
  MORE_COLOURS,
  MORE_COLOURS_FACET,
  MIX_MATCH,
} from "../state/modules/search/constants";

export const formatCategoryBreadcrumbs = (breadcrumbs) =>
  breadcrumbs
    .slice(1)
    .filter((breadcrumb) => breadcrumb.Label !== undefined)
    .map((breadcrumb) => breadcrumb.Label)
    .join(TRACKING_WORD_DELIMITER)
    .toLowerCase();

const buildProductBadges = (product) => {
  const badgeConditions = [
    { condition: product.isSellingFast, badge: "Selling Fast" },
    { condition: product.isRestockingSoon, badge: "Restocking Soon" },
    {
      condition:
        product.badgeType === MORE_COLOURS ||
        product.badgeType === MORE_COLOURS_FACET,
      badge: "More Colours",
    },
    { condition: product.badgeType === MIX_MATCH, badge: "Mix & Match" },
    { condition: product.earlyAccess, badge: "Early Access" },
    {
      condition:
        product.isSale ||
        product.isOutlet ||
        product.price?.isMarkedDown ||
        product.price?.isOutletPrice,
      badge: "Sale",
    },
  ];

  return badgeConditions
    .filter(({ condition }) => condition)
    .map(({ badge }) => badge);
};

export const buildItemsDataTemplate = (product, index) => {
  const template = {
    item_name: product.description,
    priceLocalCurrency: product.priceLocalCurrency,
    item_brand: product.brandName,
    item_variant: product.colour,
    itemType: "Product",
    quantity: 1,
    index: index + 1,
    google_business_vertical: "retail",
  };

  if (product.id) {
    template.productId = product.id.toString();
  } else if (product.productId) {
    template.productId = product.productId.toString();
  }

  if (product.productCode) {
    template.productCode = product.productCode.toString();
  }

  const badges = buildProductBadges(product);
  if (badges.length > 0) {
    template.badges = badges;
  }

  return template;
};

export const buildEcommerceItems = (returnedProductList, productList) => {
  const sourceList =
    (Array.isArray(productList) && productList) ||
    (Array.isArray(returnedProductList) && returnedProductList) ||
    [];

  return sourceList.map((product, index) =>
    buildItemsDataTemplate(product, index),
  );
};

export const buildProductComponentImpressionEvent = ({
  products,
  pageNumber,
  columnCount,
  visibleRowId,
  itemListName,
  localCurrencyCode,
  requestId,
  pageSize,
}) => {
  const matchedRowItem = products.find(
    ({ product: rowProduct }) =>
      `product-${rowProduct?.tileId}` === visibleRowId,
  );

  if (!matchedRowItem) {
    return null;
  }

  const getAbsoluteProductIndex = (pageNumber, onPageProductIndex, pageSize) =>
    (pageNumber - 1) * pageSize + onPageProductIndex;

  const absoluteProductIndex = getAbsoluteProductIndex(
    pageNumber,
    matchedRowItem.onPageProductIndex,
    pageSize,
  );
  const rowNumber = Math.floor(absoluteProductIndex / columnCount);

  const rowProducts = products.filter((rowItem) => {
    const productRowIndex = Math.floor(
      getAbsoluteProductIndex(
        pageNumber,
        rowItem.onPageProductIndex,
        pageSize,
      ) / columnCount,
    );

    return productRowIndex === rowNumber;
  });

  const mappedRowProducts = rowProducts.map((rowItem) =>
    buildItemsDataTemplate(rowItem.product, rowItem.onPageProductIndex),
  );

  return {
    item_list_name: itemListName,
    row: rowNumber + 1,
    ecommerce: {
      items: mappedRowProducts,
      currency: "GBP",
      localCurrencyCode,
    },
    ...(requestId ? { request_id: requestId } : {}),
  };
};
